import { ProductContent } from "./product-content";
import { ProductPrice } from "./product-price";
import { ProductCategory } from "../_models/product-category";

export class Product {
  Id: number;
  ItemType: number;
  PackageType?: string;
  EntryType?: string;
  Name: string;
  Active: boolean;
  Code: string;
  Category: string;
  Description: string;
  ImageUrl: string;
  Country: string;
  Price: number;
  Discount: number;
  Points: number;
  Weight: number;
  SKU: string;
  Content: ProductContent[] = [];
  Prices: ProductPrice[] = [];
  Categories: number[] = [];
}
